import {useEffect,useState} from "react";
import {Download,FileText,ImageOff} from "lucide-react";
import {API} from "../lib/api";

export default function ChatMedia({leadId,message}) {
  const [url,setUrl]=useState("");
  const [error,setError]=useState(false);
  useEffect(()=>{
    let mounted=true,objectUrl="";
    API.get(`/leads/${leadId}/messages/${message.id}/media`,{responseType:"blob"})
      .then(({data})=>{if(mounted){objectUrl=URL.createObjectURL(data);setUrl(objectUrl)}})
      .catch(()=>{if(mounted)setError(true)});
    return ()=>{mounted=false;if(objectUrl)URL.revokeObjectURL(objectUrl)};
  },[leadId,message.id]);
  if(error)return <div className="flex items-center gap-2 rounded-lg bg-black/15 p-3 text-xs"><ImageOff size={16}/>Media unavailable from OpenWA</div>;
  if(!url)return <div className="text-xs opacity-60 py-3">Loading media…</div>;
  const type=message.media_type;
  return <div className="mb-2 max-w-[340px]">
    {type==="image"||type==="sticker"?<a href={url} target="_blank" rel="noreferrer"><img src={url} alt={message.media_filename||"WhatsApp image"} className="max-h-72 w-auto rounded-lg object-contain"/></a>:null}
    {type==="video"?<video controls preload="metadata" src={url} className="max-h-72 w-full rounded-lg"/>:null}
    {type==="audio"?<audio controls src={url} className="w-full max-w-64"/>:null}
    {type==="document"?<a href={url} download={message.media_filename||"WhatsApp-document"} className="flex items-center gap-2 rounded-lg bg-black/15 p-3 text-sm"><FileText size={18}/><span className="truncate">{message.media_filename||"Document"}</span><Download size={15}/></a>:null}
  </div>;
}
